import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { SchedaintenseMainComponent } from './schedaintense-view';
import { SchedaintenseResultComponent, SchedaintenseResultsComponent} from './schedaintense-result';
import { ListErrorsComponent } from './list-errors.component';
import { TruncatePipe, DifficoltaPipe, DistanzaPipe, DurataPipe, TappaCounterPipe, ImmaginePipe, StagionePipe, VisitabilePipe, FormattaDataPipe, StatusPipe, FormattaTimespanPipe, FruizionePipe, StatusTextPipe, ColoreAlertPipe, RimuoviDuplicatiPipe, ValidatoPipe, ColorStatusTextPipe, DislivelloPositivoPipe, DislivelloNegativoPipe, PendenzaPipe, OstDurataPipe, IconFilePipe} from '../core/pipes';
import { SchedaintenseListComponent, SchedaintensePreviewComponent} from '../shared/schedaintense-home';
import { SuiModule} from 'ng2-semantic-ui';
// import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { EsperienzaShareMainComponent, EsperienzaShareMainDetailsComponent, EsperienzaShareMainHeaderComponent } from '../shared/esperienza-share';
import { EsperienzaProfileListComponent, EsperienzaProfileComponent } from '../shared/esperienza-profile';
import { EsperienzaListComponent, EsperienzaPreviewComponent } from './esperienza-home';
import { EsperienzaMainComponent } from './esperienza-view';
import { EsperienzaAdminSearchComponent, EsperienzaAdminListComponent, EsperienzaAdminPreviewComponent} from './esperienza-admin';
import { OstViewComponent} from './ost-view/ost-view.component';
import { OstResultComponent, OstResultListComponent} from './ost-result/';
import {  ItemViewComponent } from './item-view';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';  
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SimpleModalComponent } from '../core/templates/simple-modal.component';
import { Angulartics2Module } from 'angulartics2';
import { RecaptchaModule } from 'ng-recaptcha';
import { ModalComponent } from './modal/modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    SuiModule,
    // LeafletModule,
    BrowserAnimationsModule,
    DragDropModule,
    TranslateModule,
    AngularEditorModule,
    Angulartics2Module,
    RecaptchaModule.forRoot()
  ],
  declarations: [
    SchedaintenseListComponent,
    SchedaintensePreviewComponent,
    SchedaintenseResultComponent,
    SchedaintenseResultsComponent,
    ListErrorsComponent,
    TruncatePipe,
    DistanzaPipe,
    DifficoltaPipe,
    DurataPipe,
    OstDurataPipe,
    TappaCounterPipe,
    ImmaginePipe,
    StagionePipe,
    VisitabilePipe,
    FormattaDataPipe,
    StatusPipe,
    FormattaTimespanPipe,
    FruizionePipe,
    StatusTextPipe,
    ColoreAlertPipe,
    IconFilePipe,
    RimuoviDuplicatiPipe,
    ValidatoPipe,
    ColorStatusTextPipe,
    DislivelloPositivoPipe,
    DislivelloNegativoPipe,
    PendenzaPipe,
    EsperienzaListComponent,
    EsperienzaPreviewComponent,
    EsperienzaMainComponent,
    EsperienzaProfileComponent,
    EsperienzaProfileListComponent,
    EsperienzaAdminSearchComponent,
    EsperienzaAdminListComponent,
    EsperienzaAdminPreviewComponent,
    EsperienzaShareMainComponent,
    EsperienzaShareMainDetailsComponent,
    EsperienzaShareMainHeaderComponent,
    SchedaintenseMainComponent,
    OstViewComponent,
    SimpleModalComponent,
    OstResultComponent,
    OstResultListComponent,
    ItemViewComponent,
    ModalComponent
  ],
  exports: [
    SchedaintenseListComponent,
    SchedaintensePreviewComponent,
    SchedaintenseResultComponent,
    SchedaintenseResultsComponent,
    SchedaintenseMainComponent,
    EsperienzaListComponent,
    EsperienzaPreviewComponent,
    EsperienzaMainComponent,
    EsperienzaProfileComponent,
    EsperienzaProfileListComponent,
    EsperienzaShareMainComponent,
    EsperienzaShareMainDetailsComponent,
    EsperienzaShareMainHeaderComponent,
    EsperienzaAdminSearchComponent,
    EsperienzaAdminListComponent,
    EsperienzaAdminPreviewComponent,
    ItemViewComponent,
    OstViewComponent,
    OstResultComponent,
    OstResultListComponent,
    SimpleModalComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ListErrorsComponent,
    RouterModule,
    TruncatePipe,
    DifficoltaPipe,
    DistanzaPipe,
    DurataPipe,
    OstDurataPipe,
    TappaCounterPipe,
    ImmaginePipe,
    StagionePipe,
    VisitabilePipe,
    FormattaDataPipe,
    StatusPipe,
    IconFilePipe,
    StatusTextPipe,
    FormattaTimespanPipe,
    ColoreAlertPipe,
    RimuoviDuplicatiPipe,
    ColorStatusTextPipe,
    DislivelloPositivoPipe,
    DislivelloNegativoPipe,
    PendenzaPipe,
    SuiModule,
    TranslateModule,
    AngularEditorModule,
    BrowserAnimationsModule,
    Angulartics2Module,
    RecaptchaModule,
    ModalComponent
  ]
})
export class SharedModule {}
